import { View, Text } from '@react-pdf/renderer';

import { Row, QuarterKey } from 'components/EditableTable/types';

interface PdfTableProps {
  data: Row[];
  title: string;
  columns: ('title' | QuarterKey)[];
}

export const PdfTable = ({ data, title, columns }: PdfTableProps) => {
  const headers = [...columns.map(l => l.replace('q', 'Q').replace('_', ' '))];

  return (
    <View
      style={{
        marginHorizontal: '20px',
        border: '1px solid #F2F2F2',
        borderRadius: '8px',
        overflow: 'hidden'
      }}
    >
      <View style={{ flexDirection: 'row', backgroundColor: '#F2F2F2' }}>
        {headers.map((col, i) => (
          <Text
            key={i}
            style={{
              padding: 4,
              fontSize: 8,
              color: '#151515',
              fontWeight: 'semibold',
              borderBottom: '1px solid #F2F2F2',
              borderRight:
                i === headers.length - 1 ? 'none' : '1px solid #F2F2F2',
              ...(col === 'title' ? { width: '150px' } : { flex: 1 })
            }}
          >
            {col === 'title' ? title : col}
          </Text>
        ))}
      </View>

      {data.map((row, rowIndex) => (
        <View key={rowIndex} style={{ flexDirection: 'row' }}>
          {columns.map((col, colIndex) => (
            <Text
              key={colIndex}
              style={{
                padding: 4,
                fontSize: 8,
                color: '#5C5C5C',
                borderRight:
                  colIndex === columns.length - 1
                    ? 'none'
                    : '1px solid #F2F2F2',
                borderBottom:
                  rowIndex === data.length - 1 ? 'none' : '1px solid #F2F2F2',
                ...(col === 'title' ? { width: '150px' } : { flex: 1 })
              }}
            >
              {String(row[col] ?? '')}
            </Text>
          ))}
        </View>
      ))}
    </View>
  );
};
